export const gameLibraryIcon = {
  icon: [
    // SVG viewbox width (in pixels)
    120,

    // SVG viewbox height (in pixels)
    120,

    // Aliases (not needed)
    [],

    // Unicode as hex value (not needed)
    "",

    // SVG path data
    "m116.4,36.5c-1.7-1.6-3.8-2.8-6-3.2C101.4,13.6,82.8,0,61.3,0S21.4,13.4,12.3,32.9h0c-6.8,0-12.3,5.4-12.3,12v27.6c0,5.5,4.8,10.1,10.9,10.6,8.5,21.4,28.2,36.8,50.4,36.8s42.3-15.7,50.7-37.4c4.6-1.5,7.9-5.5,7.9-10v-27.6c.2-3.2-1.1-6.2-3.5-8.5ZM18.5,83.3h19.8c3.7,0,7.1-1.4,9.4-3.8l11.4-11.8c.3-.3,1-.4,1.6,0l11.5,11.7c2.3,2.4,5.7,3.9,9.4,3.9h22.6c-7.9,17.5-24.3,29.8-42.8,29.8s-34.8-12.3-42.8-29.8ZM61.3,6.9c17.5,0,32.8,10.5,41.2,26.1H20.1C28.5,17.3,43.8,6.9,61.3,6.9Z " +
    "M60.6,98.7c-7.8,0-13.4-4.8-13.7-5-1-.9-1.1-2.5-.2-3.5.9-1,2.5-1.1,3.6-.2h0s4.5,3.8,10.3,3.8,10.3-3.7,10.3-3.8c1-.9,2.6-.8,3.6.2.9,1,.8,2.6-.2,3.5-.2.2-5.8,5-13.7,5Z"
  ],
  iconName: "unltd-connect-icons-game-library",
  prefix: "unltd-connect-icons"
};
